<template>
  <div class="hpanel">
    <div class="panel-heading">
      Files list
      <div class="panel-tools" v-if="origin === null">
        <button class="btn btn-xs btn-info " @click="openModalVerifyTimestamp(null)"><i class="fas fa-certificate"></i> Verify Protection</button>

        <button class="btn btn-xs btn-info " @click="openModalTimestamp(null)"><i class="fa fa-plus"></i> New Protection</button>
      </div>
    </div>
    <div class="panel-body">
      <div class="table-responsive">
        <table class="table table-condensed">
          <thead>
          <tr>
            <th class="col-xs-2 col-md-2 col-lg-2">Filename</th>
            <th class="col-xs-2 col-md-2 col-lg-2">Project</th>
            <th class="col-xs-2 col-md-2 col-lg-1">Content</th>
            <th class="col-xs-2 col-md-2 col-lg-1">Type</th>
            <th class="col-xs-2 col-md-2 col-lg-2 text-center">Status<br><span style="font-size: 12px;font-weight: normal">pdf generation</span></th>
            <template v-if="$user.isBicWorld() && (origin === null || origin === 'project_report_pdf')">
              <th class="col-xs-1 col-md-1 col-lg-2 text-center">Status<br><span style="font-size: 12px;font-weight: normal">KMS upload</span></th>
            </template>
            <th class="col-xs-2 col-md-2 col-lg-2 text-center">Status<br>
              <a href="https://academy.idexlab.com/hc/en-us/articles/360022046879-Innovation-protection-principles" target="_blank"> <span style="font-size: 12px;font-weight: normal">File protection <i class="fa fa-info-circle text-info"></i></span></a>
            </th>
            <th class="col-xs-2 col-md-2 col-lg-1 text-center">Actions</th>
          </tr>
          </thead>

          <tbody v-if="documents.length !== 0">
          <tr v-for="(fileExport, key) in documents" :key="key">
            <td>
              <span v-html="getFileIcon(fileExport.extension)"></span>
              <a :href="fileExport.link" target="_blank"> {{fileExport.name}}</a>
            </td>
            <td>
              <template v-if="fileExport.project">
                <router-link :to="{name: 'ProjectDetails', params: {id: fileExport.project_id}}">
                  {{fileExport.project.name}}
                </router-link>
              </template>
              <template v-else> n.a.</template>
            </td>
            <td>
              <span v-if="fileExport.asynchronous_file && fileExport.asynchronous_file.origin">{{fileExport.asynchronous_file.origin.replace('_', ' ')}}</span>
              <span v-else>Other (external)</span>
            </td>
            <td>
              <span v-if="fileExport.timestamped_file && fileExport.timestamped_file.type">{{fileExport.timestamped_file.type.name}}</span>
              <span v-else>Platform Content</span>
            </td>

            <td class="text-center">
              <template v-if="fileExport.asynchronous_file">
                <span v-if="fileExport.asynchronous_file.status === 'PENDING'" class="label label-warning">{{ fileExport.asynchronous_file.status }}</span>
                <span v-if="fileExport.asynchronous_file.status === 'RUNNING'" class="label label-info">{{ fileExport.asynchronous_file.status }}</span>
                <template v-if="fileExport.asynchronous_file.status === 'FINISHED'">
                  <span class="label label-success">{{ fileExport.asynchronous_file.status }}</span> <br>
                  <small> <i>{{ fileExport.asynchronous_file.created_at | moment('LLL') }}</i></small>
                </template>
                <span v-if="fileExport.asynchronous_file.status === 'ERROR'" class="label label-danger">{{ fileExport.asynchronous_file.status }}</span>
              </template>
            </td>

            <template v-if="$user.isBicWorld() && (origin === null || (fileExport.asynchronous_file !== null && fileExport.asynchronous_file.origin === 'project_report_pdf'))">
              <td class="text-center">
                <template v-if="fileExport.asynchronous_file && fileExport.asynchronous_file.status === 'FINISHED' && fileExport.asynchronous_file.origin === 'project_report_pdf'">
                  <template v-if="!fileExport.asynchronous_file.status_upload">
                    <button class="btn btn-xs btn-warning btn-outline" @click="openModalBic(fileExport, $event)">Upload to kms</button>
                  </template>
                  <template v-else>
                    <span v-if="fileExport.asynchronous_file.status_upload === 'PENDING'" class="label label-warning">{{ fileExport.asynchronous_file.status_upload }}</span>
                    <span v-if="fileExport.asynchronous_file.status_upload === 'RUNNING'" class="label label-info">{{ fileExport.asynchronous_file.status_upload }}</span>
                    <template v-if="fileExport.asynchronous_file.status_upload === 'FINISHED'">
                      <span  class="label label-success">{{ fileExport.asynchronous_file.status_upload }} </span>
                    </template>
                    <span v-if="fileExport.asynchronous_file.status_upload === 'ERROR'" class="label label-danger">{{ fileExport.asynchronous_file.status_upload }}</span>
                    <br>
                    <small><i>{{ fileExport.asynchronous_file.updated_at | moment('LLL') }}</i></small>
                  </template>
                </template>
              </td>
            </template>

            <template v-if="fileExport.filename !== null">
              <td class="text-center">
                <template v-if="fileExport.timestamped_file === null">
                  <button class="btn btn-xs btn-info btn-outline" @click="openModalTimestamp(fileExport, $event)"> Protect</button>
                </template>
                <template v-else>
                  <span v-if="fileExport.timestamped_file.status === 'PENDING'" class="label label-warning">{{ fileExport.timestamped_file.status }}</span>
                  <span v-if="fileExport.timestamped_file.status === 'RUNNING'" class="label label-info">{{ fileExport.timestamped_file.status }}</span>
                  <template v-if="fileExport.timestamped_file.status === 'FINISHED'">
                    <span  class="label label-success">PROTECTED</span>
                  </template>
                  <span v-if="fileExport.timestamped_file.status === 'ERROR'" class="label label-danger">{{ fileExport.timestamped_file.status }}</span>
                  <br>
                  <small><i>{{ fileExport.timestamped_file.updated_at | moment('LLL') }}</i></small>
                </template>
              </td>
            </template>
            <td class="text-center">
              <div class="dropdown">
                <button class="btn-outline btn btn-xs btn-info dropdown-toggle" id="dropdownMenuDocuments" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                  <i class="pe-7s-more pe-1x fa-rotate-90"></i>
                </button>
                <ul class="dropdown-menu pe-ul pull-right" aria-labelledby="dropdownMenuDocuments">
                  <li>
                    <a class="" :href="fileExport.link" target="_blank">
                      <i class="fas fa-eye text-info"></i> Preview File
                    </a>
                  </li>
                  <li>
                    <a href="#" @click="download(fileExport)">
                      <i class="fas fa-download text-info"></i> Download File
                    </a>
                  </li>
                  <li>
                    <a href="#" @click="openModalFileDetails(fileExport, $event)">
                      <i class="fa fa-search text-info"></i> View Details
                    </a>
                  </li>
                  <template v-if="$user.isBicWorld() && fileExport.asynchronous_file && fileExport.asynchronous_file.status === 'FINISHED' && fileExport.asynchronous_file.origin === 'project_report_pdf'">
                    <li role="separator" class="divider"></li>
                    <li :class="{disabled: fileExport.asynchronous_file.status_upload !== null}">
                      <a href="#" @click="openModalBic(fileExport, $event)">
                        <i class="fas fa-file-upload text-warning"></i> Upload to KMS
                      </a>
                    </li>
                  </template>
                  <template v-if="fileExport.timestamped_file === null || fileExport.timestamped_file.status === 'FINISHED'">
                    <li role="separator" class="divider"></li>
                    <li v-if="fileExport.timestamped_file === null">
                      <a href="#" @click="openModalTimestamp(fileExport, $event)" title="Protect your file by recording it on the blockchain">
                        <i class="fas fa-link text-success"></i> Protect
                      </a>
                    </li>
                    <template v-else>
                      <li v-if="fileExport.timestamped_file.status === 'FINISHED'">
                        <router-link :to="{name: 'TimestampedFileCertification', params: {poe_id: fileExport.timestamped_file.id}}"><i class="fa fa-certificate text-info"></i> Generate <br>Proof of Existence</router-link>
                      </li>
                    </template>
                  </template>
                  <template v-if="fileExport.timestamped_file === null && fileExport.asynchronous_file === null">
                    <li role="separator" class="divider"></li>
                    <li>
                      <a href="#" @click="remove(fileExport)">
                        <i class="fas fa-trash text-danger"></i> Remove
                      </a>
                    </li>
                  </template>
                </ul>
              </div>
            </td>
          </tr>
          </tbody>
          <tbody v-else>
          <tr class="text-center">
            <td colspan="7"> Empty List</td>
          </tr>
          </tbody>
        </table>
      </div>
      <upload-file-bic ref="uploadFileBic" @dataBicForUpload="uploadBic"></upload-file-bic>
      <action-modal-timestamp ref="modalTimestamp"/>
      <file-details ref="modalFileDetails"/>
      <verify-timestamp ref="modalVerifyTimestamp"></verify-timestamp>
    </div>
    <limit-plan ref="limitPlan" :on-hidden="() => $emit('input', null)"></limit-plan>
  </div>
</template>
<style scoped>
.table td {
  vertical-align: middle !important;
}

.dropdown > ul > li i{
  color: #3498db;
  font-weight: bold;
}

.dropdown > ul > li a{
  font-size: 12px;
}

.dropdown > ul > li{
  margin-bottom: 5px;
  font-size: 12px;
}

</style>
<script>

import UploadFileBic from '../modal/UploadFileBic'
import ActionModalTimestamp from '../../components/Timestamp/ActionModalTimestamp'
import VerifyTimestamp from '../Timestamp/VerifyTimestamp'
import FileDetails from '../../components/modal/FileDetails'
import LimitPlan from '../../components/LimitPlan'

export default {
  components: {FileDetails, VerifyTimestamp, UploadFileBic, ActionModalTimestamp, LimitPlan},
  name: 'MyDocuments',
  props: {
    projectId: {
      require: false,
      default: null
    },
    origin: {
      require: false,
      default: null
    }
  },
  data () {
    return {
      documents: [],
      timer: null,
      modalTimestampAction: null,
      timestampFile: null,
      errorPdf: null,
      projectReportBlob: null,
      fileName: null,
      asynchronousFileId: null
    }
  },
  methods: {
    getResources: function () {
      if (this.projectId === null) {
        this.axios.get('file/all?relations={project.owner,asynchronousFile,timestampedFile.type}').then((response) => {
          this.documents = response.data
        })
      } else {
        this.axios.get('file/asynchronous/project/' + this.projectId + '/origin/' + this.origin + '?relations={project.owner,asynchronousFile,timestampedFile.type}').then((response) => {
          this.documents = response.data
        })
      }
    },
    download: function (fileExport) {
      this.axios.get('file/' + fileExport.id + '/download', { responseType: 'blob' }).then((response) => {
        var newBlob = new Blob([response.data], {type: 'application/pdf'})

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob)
          return
        }

        let url = window.URL.createObjectURL(newBlob)
        let a = document.createElement('a')
        document.body.appendChild(a)
        a.style = 'display: none'
        a.href = url
        a.download = fileExport.name + '.' + fileExport.extension
        a.click()
        window.URL.revokeObjectURL(url)
      })
    },
    remove: function (fileExport) {
      this.axios.delete('file/' + fileExport.id).then((response) => {
        this.$notify({
          type: 'success',
          title: 'Document deleted',
          content: '',
          placement: 'bottom-right'
        })
        this.getResources()
      }).catch(() => {
        this.$notify({
          type: 'danger',
          title: 'an error has occurred',
          content: 'an error occurred while deleting the document, please consult our support',
          placement: 'bottom-right'
        })
      })
    },
    openModalBic: function (fileExport, event) {
      if (event) {
        event.preventDefault()
      }

      if (fileExport.asynchronous_file.status_upload === null) {
        this.$refs.uploadFileBic.setTitle(fileExport.project.name)
        this.$refs.uploadFileBic.setFileExportId(fileExport.asynchronous_file.id)
        this.$refs.uploadFileBic.openModal()
      }
    },
    openModalTimestamp: function (fileExport, event) {
      if (event) {
        event.preventDefault()
      }

      if (!this.$user.canBlockchain()) {
        this.$refs.limitPlan.show('blockchain')
        return false
      }

      this.$refs.modalTimestamp.fillForm(fileExport)
      this.$refs.modalTimestamp.openModal()
    },
    uploadBic: function (data) {
      let fileExportId = data.fileExportId
      if (fileExportId !== null && typeof fileExportId !== 'undefined') {
        this.axios.post('bicworld/upload/' + fileExportId, data).then((response) => {
          this.$notify({
            type: 'success',
            title: 'upload document to KMS will start',
            content: '',
            placement: 'bottom-right'
          })
        })
      }
    },
    openModalVerifyTimestamp: function () {
      if (event) {
        event.preventDefault()
      }

      if (!this.$user.canBlockchain()) {
        this.$refs.limitPlan.show('blockchain')
        return false
      }

      this.$refs.modalVerifyTimestamp.openModal()
    },
    openModalFileDetails: function (file) {
      if (event) {
        event.preventDefault()
      }

      this.$refs.modalFileDetails.setFileId(file.id)
      this.$refs.modalFileDetails.openModal()
    },
    getFileIcon: function (extension) {
      let iconArray = {'jpg': 'image', 'png': 'image', 'jpeg': 'image', 'xls': 'excel', 'xlsx': 'excel', 'csv': 'csv', 'pdf': 'pdf', 'word': 'word', 'odf': 'pdf'}
      return typeof iconArray[extension] !== 'undefined' ? '<i class="fas fa-file-' + iconArray[extension] + '"></i>' : null
    }
  },
  updated () {
    $('.table-responsive').on('show.bs.dropdown', function () {
      $('.table-responsive').css('overflow', 'inherit')
    })

    $('.table-responsive').on('hide.bs.dropdown', function () {
      $('.table-responsive').css('overflow', 'auto')
    })
  },
  mounted () {
    this.timer = setInterval(this.getResources, 15000)
  },
  beforeMount () {
    this.getResources()
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/documents/MyDocuments.vue